import { useContext } from "react"
import Header from "./components/Header/Header"
import SideBar from "./components/SideBar/SideBar"
import Container from "./components/Container"
import DebugContextProvider from "./context/DebugContextProvider"
import DebugInfoContext from "./context/DebugContext"
import Insights from "./components/Insights"
const DebugPageContent = () => {
    const { headerData } = useContext(DebugInfoContext)
    
    return (
        <div className="bg-mobileBg md:bg-webBg flex flex-col md:min-h-screen font-nunito divide-y divide-dividerLines">
            <Header />
            <div className="flex flex-grow divide-x divide-dividerLines ">
                <div className={`w-full ${headerData?.GEN4MacId ? 'md:w-full' : 'md:w-3/4'} `}>
                    <Insights />
                    <Container />
                </div>
                {!headerData?.GEN4MacId && (
                    <div className="w-full md:w-1/4 md:block hidden">
                        <SideBar />
                    </div>
                )}
            </div>
        </div>
    )
}

const DebugPage = () => {
    return (
        <DebugContextProvider>
            <DebugPageContent />
        </DebugContextProvider >
    )
}


export default DebugPage